import React, { useState } from 'react';
import { TriggerContainer, ContentContainer, HeaderContainer, CloseIconWrapper, BottomSheetContainer } from './style';
import { Icons } from '../Icons';
import { MEDIA_QUERIES } from '../../styles/theme';

export const BottomSheet = ({ TriggerContent = null, Content = null,
    backgroundColor = "white", maxExcludedScreenSize = MEDIA_QUERIES.tablet,
    HeaderContent = null
}) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <BottomSheetContainer maxExcludedScreenSize={maxExcludedScreenSize}>
            <TriggerContainer onClick={() => setIsOpen(true)}>
                {TriggerContent}
            </TriggerContainer>
            <ContentContainer isActive={isOpen} backgroundColor={backgroundColor}>
                <HeaderContainer onClick={() => setIsOpen(false)}>
                    {HeaderContent ? 
                        <React.Fragment>
                            {HeaderContent}
                        </React.Fragment>
                        :
                        <CloseIconWrapper>
                            <Icons icon="Cross" color="white" />
                        </CloseIconWrapper>
                    }
                </HeaderContainer>
                {Content}
            </ContentContainer>
        </BottomSheetContainer>
    )
}